import React, { useEffect, useState } from "react";
import Sidebar from "../../components/common/sidebar/sidebar";
import { Card, Row, Col, Spinner, Badge } from "react-bootstrap";
import {
  FaStore,
  FaTags,
  FaTruck,
  FaClipboardList,
  FaFileUpload,
  FaExclamationTriangle,
} from "react-icons/fa";
import { settings } from "../../helpers/settings";
import Lottie from "lottie-react";
import dashboardAnim from "../../helpers/animations/dashboard.json";
import sleepingAnim from "../../helpers/animations/sleeping.json";
import alarmAnim from "../../helpers/animations/alarm.json";

const LandingPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Kullanıcı email kontrolü
  const userEmail = localStorage.getItem("email");
  const isEmbroideryUser = userEmail === "embroidery@txmaya.com";

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    const token = localStorage.getItem("jwt_token");

    // Embroidery kullanıcısı için farklı API
    const apiUrl = isEmbroideryUser
      ? `${settings.apiURL}/get_embroidery_summary.php?user_id=${userId}`
      : `${settings.apiURL}/get_landing_summary.php?user_id=${userId}`;

    fetch(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching landing data", err);
        setLoading(false);
      });
  }, [isEmbroideryUser]);

  if (loading) {
    return (
      <div style={{ display: "flex", height: "100vh" }}>
        <div style={{ width: "250px", flexShrink: 0 }}>
          <Sidebar />
        </div>
        <div
          style={{
            flex: 1,
            padding: "2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner animation="border" variant="warning" />
        </div>
      </div>
    );
  }

  if (!data || !data.success) {
    return (
      <div style={{ display: "flex", height: "100vh" }}>
        <div style={{ width: "250px", flexShrink: 0 }}>
          <Sidebar />
        </div>
        <div style={{ flex: 1, padding: "2rem" }}>
          <h3>Failed to load dashboard data.</h3>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <div style={{ width: "250px", flexShrink: 0 }}>
        <Sidebar />
      </div>

      {/* Main content */}
      <div
        style={{
          flex: 1,
          padding: "2rem",
          overflowY: "auto",
          background: "#ffffff",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "2rem",
          }}
        >
          <h3
            style={{
              background: "linear-gradient(90deg, #5947ff, #bf70ff)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: "bold",
              margin: 0,
            }}
          >
            Welcome, {data.user.first_name} {data.user.last_name}
            {isEmbroideryUser && " (Embroidery)"}
          </h3>
          <div style={{ width: 160, height: 160 }}>
            <Lottie animationData={dashboardAnim} loop={true} />
          </div>
        </div>

        {/* EMBROIDERY KULLANICISI İÇİN ÖZEL GÖRÜNÜM */}
        {isEmbroideryUser ? (
          <>
            {/* Embroidery özet kartları */}
            <Row className="mb-4">
              <Col md={4} sm={6} xs={12}>
                <Card className="shadow-sm mb-3 summary-card">
                  <Card.Body className="d-flex align-items-center">
                    <FaClipboardList
                      size={20}
                      style={{ marginRight: "10px", color: "#6200ff" }}
                    />
                    <div>
                      <small>Embroidery Orders</small>
                      <h6 className="mb-0">
                        {data.total?.embroideryOrders ||
                          data.embroiderySummary?.embroideryOrders ||
                          0}
                      </h6>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4} sm={6} xs={12}>
                <Card className="shadow-sm mb-3 summary-card">
                  <Card.Body className="d-flex align-items-center">
                    <FaFileUpload
                      size={20}
                      style={{ marginRight: "10px", color: "#4caf50" }}
                    />
                    <div>
                      <small>Today's Embroidery Files</small>
                      <h6 className="mb-0">
                        {data.total?.filesToday ||
                          data.embroiderySummary?.embroideryFilesToday ||
                          0}
                      </h6>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4} sm={6} xs={12}>
                <Card className="shadow-sm mb-3 summary-card">
                  <Card.Body className="d-flex align-items-center">
                    <FaExclamationTriangle
                      size={20}
                      style={{ marginRight: "10px", color: "#e53935" }}
                    />
                    <div>
                      <small>Urgent Embroidery Orders</small>
                      <h6 className="mb-0">
                        {data.total?.urgentOrders ||
                          data.embroiderySummary?.urgentEmbroideryOrders ||
                          0}
                      </h6>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Embroidery özet bilgisi */}
            <Card className="shadow-sm mb-4" style={{ borderRadius: "10px" }}>
              <Card.Body>
                <Card.Title style={{ marginBottom: "1rem", fontSize: "16px" }}>
                  Embroidery Dashboard Summary
                </Card.Title>
                <Row>
                  <Col md={4}>
                    <p>
                      <strong>Total Embroidery Orders:</strong>{" "}
                      {data.embroiderySummary?.embroideryOrders || 0}
                    </p>
                  </Col>
                  <Col md={4}>
                    <p>
                      <strong>Files Uploaded Today:</strong>{" "}
                      {data.embroiderySummary?.embroideryFilesToday || 0}
                    </p>
                  </Col>
                  <Col md={4}>
                    <p>
                      <strong>Urgent Orders (&gt;24h):</strong>{" "}
                      {data.embroiderySummary?.urgentEmbroideryOrders || 0}
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </>
        ) : (
          <>
            {/* NORMAL KULLANICI İÇİN MEVCUT GÖRÜNÜM (ORİJİNAL) */}
            {/* Top summary cards */}
            <Row className="mb-4">
              <Col md={4} sm={6} xs={12}>
                <Card className="shadow-sm mb-3 summary-card">
                  <Card.Body className="d-flex align-items-center">
                    <FaClipboardList
                      size={20}
                      style={{ marginRight: "10px", color: "#5c46d6" }}
                    />
                    <div>
                      <small>Total Awaiting</small>
                      <h6 className="mb-0">
                        {data.total?.ordersAwaiting || 0}
                      </h6>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4} sm={6} xs={12}>
                <Card className="shadow-sm mb-3 summary-card">
                  <Card.Body className="d-flex align-items-center">
                    <FaTags
                      size={20}
                      style={{ marginRight: "10px", color: "#4caf50" }}
                    />
                    <div>
                      <small>Total Tagged</small>
                      <h6 className="mb-0">{data.total?.ordersTagged || 0}</h6>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4} sm={6} xs={12}>
                <Card className="shadow-sm mb-3 summary-card">
                  <Card.Body className="d-flex align-items-center">
                    <FaFileUpload
                      size={20}
                      style={{ marginRight: "10px", color: "#2196f3" }}
                    />
                    <div>
                      <small>Today's Files</small>
                      <h6 className="mb-0">{data.total?.files || 0}</h6>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* Shops */}
            <Row className="mb-4">
              {data.shops?.map((shop, idx) => (
                <Col md={4} sm={6} xs={12} key={idx} className="mb-3">
                  <Card
                    className="shadow-sm h-100 shop-card"
                    style={{
                      border: "1px solid #c9b2ff",
                      borderRadius: "10px",
                      background: "#ffffff",
                      transition: "transform 0.2s, box-shadow 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.boxShadow =
                        "0 6px 18px rgba(0,0,0,0.1)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(0,0,0,0.05)")
                    }
                  >
                    <Card.Body>
                      <Card.Title
                        style={{ fontSize: "16px", fontWeight: "600" }}
                      >
                        <FaStore
                          style={{ marginRight: "6px", color: "#3700ff" }}
                        />
                        {shop.shop_name}
                      </Card.Title>

                      {shop.ordersSummary.awaiting === 0 &&
                      shop.ordersSummary.tagged === 0 &&
                      (!shop.ordersSummary.urgent ||
                        shop.ordersSummary.urgent === 0) ? (
                        <div style={{ textAlign: "center" }}>
                          <div style={{ width: 100, margin: "0 auto" }}>
                            <Lottie animationData={sleepingAnim} loop={true} />
                          </div>
                          <p
                            style={{
                              fontSize: "13px",
                              color: "#999",
                              marginTop: "0.5rem",
                            }}
                          >
                            No orders yet
                          </p>
                        </div>
                      ) : (
                        <>
                          <p style={{ fontSize: "14px" }}>
                            <FaTruck
                              style={{ marginRight: "6px", color: "#555" }}
                            />{" "}
                            Awaiting:{" "}
                            <Badge bg="light" text="dark">
                              {shop.ordersSummary.awaiting}
                            </Badge>
                          </p>
                          <p style={{ fontSize: "14px" }}>
                            <FaTags
                              style={{ marginRight: "6px", color: "#555" }}
                            />{" "}
                            Tagged:{" "}
                            <Badge bg="light" text="dark">
                              {shop.ordersSummary.tagged}
                            </Badge>
                          </p>
                          {shop.ordersSummary.urgent > 0 && (
                            <p
                              style={{
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <FaExclamationTriangle
                                style={{ marginRight: "4px", color: "#e53935" }}
                              />
                              Urgent (&gt;24h):{" "}
                              <Badge bg="danger">
                                {shop.ordersSummary.urgent}
                              </Badge>
                              <div style={{ width: 28, height: 28 }}>
                                <Lottie animationData={alarmAnim} loop={true} />
                              </div>
                            </p>
                          )}
                        </>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}

        {/* Today's uploaded files (her iki kullanıcı için) */}
        <Card className="shadow-sm" style={{ borderRadius: "10px" }}>
          <Card.Body>
            <Card.Title style={{ marginBottom: "1rem", fontSize: "16px" }}>
              {isEmbroideryUser
                ? "Today's Embroidery Files"
                : "Today's Uploaded Files"}
            </Card.Title>
            {!data.todayFiles || data.todayFiles.length === 0 ? (
              <p>No files uploaded today.</p>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table className="table table-sm table-hover align-middle text-center">
                  <thead className="table-light">
                    <tr>
                      <th>File Name</th>
                      <th>Folder</th>
                      <th>Drive Folder</th>
                      <th>Uploaded Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.todayFiles.map((file, idx) => (
                      <tr key={idx}>
                        <td>{file.file_name}</td>
                        <td>{file.folderName}</td>
                        <td>{file.drive_date_folder}</td>
                        <td>{file.uploaded_date}</td>
                        <td>
                          <Badge
                            bg={
                              file.status?.startsWith("Printed")
                                ? "success"
                                : file.status === "Deleted"
                                ? "secondary"
                                : file.status?.includes("Uploaded")
                                ? "info"
                                : "danger"
                            }
                            style={{ fontSize: "0.75rem" }}
                          >
                            {file.status}
                          </Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default LandingPage;
